/**
 * Sims
 * http://simsrecycling.com
 *
 * Copyright (c) 2017 10up
 * Licensed under the GPL-2.0+ license.
 */

( function( window, $ ) {
	'use strict';

	var coverageMaps = [];

	/**
	 * Object to represent a coverage Map.
	 *
	 * @param {object} el The container element for the map.
	 *
	 * @returns {void}
	 */
	var CoverageMap = function( el ) {
		this.$el = null;
		this.$mapEl = null;
		this.settings = {};

		this.init( el );
	};

	CoverageMap.prototype = {
		/**
		 * Initialize the coverage map.
		 *
		 * @param {object} el The container element for the coverage map.
		 *
		 * @returns {void}
		 */
		init: function( el ) {
			if (
				!el
			) {
				return;
			}

			this.$el = $( el );
			this.$mapEl = this.$el.find( '.map' );

			this.initSettings();
			this.initMap();
		},

		/**
		 * Initialize the settings.
		 *
		 * @returns {void}
		 */
		initSettings: function() {
			if ( 'undefined' !== typeof coverageMapAPISettings ) {
				this.settings = coverageMapAPISettings;
			}
		},

		getSetting: function( setting ) {
			if ( this.settings && this.settings.hasOwnProperty( setting ) ) {
				return this.settings[setting];
			} else {
				return null;
			}
		},

		/**
		 * Initialize events for the map.
		 *
		 * @returns {void}
		 */
		initMap: function() {
			this.getLocations();
		},

		/**
		 * Populate the map.
		 *
		 * @param {array} locations The locations for the map.
		 *
		 * @returns {void}
		 */
		populateMap: function( locations ) {
			var $map = this.getMapEl();
			var coverageColor = this.getSetting( 'coverageColor' );
			var noCoverageColor = this.getSetting( 'noCoverageColor' );
			var apiKey = this.getSetting( 'googleMapsAPIKey' );

			if ( !google || !google.charts || !$map.length || !Array.isArray( locations ) || !apiKey ) {
				return;
			}

			google.charts.load( 'current', {
				'packages': ['geochart'],
				'mapsApiKey': apiKey
			} );

			google.charts.setOnLoadCallback( function() {
				var coverageLocations = [];

				for ( var i = 0; i < locations.length; i++ ) {
					coverageLocations.push( [locations[i]] );
				}

				var data = google.visualization.arrayToDataTable( coverageLocations );

				var options = {
					colorAxis: {
						colors: [coverageColor]
					},
					defaultColor: coverageColor,
					datalessRegionColor: noCoverageColor
				};

				var chart = new google.visualization.GeoChart( $map[0] );

				chart.draw( data, options );
			} );
		},

		/**
		 * Get the container element for finder.
		 *
		 * @returns {object} The element.
		 */
		getEl: function() {
			return this.$el;
		},

		/**
		 * Get the container element for the map.
		 *
		 * @returns {object} The element.
		 */
		getMapEl: function() {
			return this.$mapEl;
		},

		/**
		 * Get locations via an AJAX request.
		 *
		 * @returns {void}
		 */
		getLocations: function() {
			var url = this.getSetting( 'coverageMapAPIGetLocationsURL' ),
				data = {},
				self = this;

			data._wpnonce = this.getSetting( 'nonce' );

			if ( !url ) {
				return;
			}

			$.ajax( {
				url: url,
				method: 'GET',
				dataType: 'json',
				data: data
			} ).success( function( response ) {
				self.handleGetLocationsResponse( response );
			} );
		},

		/**
		 * Handle the response returned when requesting locations.
		 *
		 * @param {string} response The JSON response containing map markers.
		 *
		 * @returns {void}
		 */
		handleGetLocationsResponse: function( response ) {
			if ( !response ) {
				return;
			}

			var locations = response;

			this.populateMap( locations );
		}
	};

	$( document ).ready( function() {
		$( '.coverage-map' ).each( function() {
			var map = new CoverageMap( this );

			coverageMaps.push( map );
		} );
	} );

} )( window, jQuery );
